import { SHAREPOINT_SITE, SHAREPOINT_SITE_PATH, PAYOUTS_LIST } from "./authConfig";

const GRAPH_BASE = "https://graph.microsoft.com/v1.0";

async function getToken(msalInstance, loginRequest) {
  const accounts = msalInstance.getAllAccounts();
  try {
    const response = await msalInstance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
    return response.accessToken;
  } catch (e) {
    const response = await msalInstance.acquireTokenPopup({ ...loginRequest, account: accounts[0] });
    return response.accessToken;
  }
}

export async function fetchPayouts(msalInstance, loginRequest) {
  const token = await getToken(msalInstance, loginRequest);

  const siteRes  = await fetch(`${GRAPH_BASE}/sites/${SHAREPOINT_SITE}:${SHAREPOINT_SITE_PATH}`, { headers: { Authorization: `Bearer ${token}` } });
  const siteData = await siteRes.json();
  const siteId   = siteData.id;

  const listRes  = await fetch(`${GRAPH_BASE}/sites/${siteId}/lists?$filter=displayName eq '${PAYOUTS_LIST}'`, { headers: { Authorization: `Bearer ${token}` } });
  const listData = await listRes.json();
  const listId   = listData.value[0].id;

  let items = [];
  let url   = `${GRAPH_BASE}/sites/${siteId}/lists/${listId}/items?$expand=fields&$top=500`;
  while (url) {
    const res  = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    items = [...items, ...data.value];
    url   = data["@odata.nextLink"] || null;
  }

  return items.map(item => {
    const f = item.fields;
    return {
      id:              item.id,
      product:         f.Title || "",
      profit:          parseFloat(f.Profit) || 0,
      company:         parseFloat(f.Company) || 0,
      kaiser:          parseFloat(f.Kaiser) || 0,
      saim:            parseFloat(f.Saim) || 0,
      faisal:          parseFloat(f.Faisal) || 0,
      payoutDate:      f.Profit_x0020_Payout_x0020_Date || null,
      created:         f.Created || null,
      createdBy:       f.Author?.LookupValue || "",
    };
  }).sort((a, b) => new Date(a.created) - new Date(b.created));
}
